import { REDUCE_USER_INTERFACE } from '../../constants/actions/storefront';

export default function reduceUserInterface(payload) {
    return {
        type: REDUCE_USER_INTERFACE,
        payload,
    };
}
